/**
 * Add new categories as needed to this enum for classification purposes.
 */
export enum Category {
  Bridge = 'Bridge',
  Community = 'Community',
  Defi = 'Defi',
  Gaming = 'Gaming',
  Indexer = 'Indexer',
  Paymaster = 'Paymaster',
  NFT = 'NFT',
  Social = 'Social',
  Wallet = 'Wallet',
  RWA = 'RWA',
  Prediction = 'Prediction Markets',
  SocialFiGame = 'SocialFi Game',
}
